import { ZeusRbacRole } from 'api/types/userApiTypes'
import { VoucherAction, VoucherStatus } from 'api/types/voucher/voucherEnums'

export type StatusRole =
  | ZeusRbacRole.ZeusOperator
  | ZeusRbacRole.ZeusAuditor
  | ZeusRbacRole.ZeusApprover
  | ZeusRbacRole.ZeusCertifier

export const statusRoleAction = (
  isResponsibleOfficer: boolean
): Record<VoucherStatus, Record<StatusRole, Record<VoucherAction, boolean>>> => ({
  [VoucherStatus.Draft]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: true,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: true,
      [VoucherAction.RemoveTransactions]: true,
      [VoucherAction.EditTransactions]: true,
      [VoucherAction.EditAllFields]: true,
      [VoucherAction.EditDirectoriteOffice]: true,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: isResponsibleOfficer,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: true,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.PendingAudit]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: isResponsibleOfficer,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: true,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: true,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: true,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: true,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.PendingApproval]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: isResponsibleOfficer,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: true,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: true,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: true,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: true,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.PendingCertification]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: isResponsibleOfficer,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: true,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: true,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: true,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: true,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.PendingSync]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: true,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: true,
      [VoucherAction.DownloadPdf]: true,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.Synced]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: true,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: true,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: true,
    },
  },
  [VoucherStatus.Deleted]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
  [VoucherStatus.Cancelled]: {
    [ZeusRbacRole.ZeusOperator]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusAuditor]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusApprover]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
    [ZeusRbacRole.ZeusCertifier]: {
      [VoucherAction.Create]: false,
      [VoucherAction.ViewInTransactions]: true,
      [VoucherAction.AddTransactions]: false,
      [VoucherAction.RemoveTransactions]: false,
      [VoucherAction.EditTransactions]: false,
      [VoucherAction.EditAllFields]: false,
      [VoucherAction.EditDirectoriteOffice]: false,
      [VoucherAction.AddComment]: false,
      [VoucherAction.Rework]: false,
      [VoucherAction.Revert]: false,
      [VoucherAction.Submit]: false,
      [VoucherAction.Audit]: false,
      [VoucherAction.Approve]: false,
      [VoucherAction.Certify]: false,
      [VoucherAction.Sync]: false,
      [VoucherAction.DownloadPdf]: false,
      [VoucherAction.Delete]: false,
      [VoucherAction.Cancel]: false,
    },
  },
})
